import APICall from '../utils/APICall';

export default class  BillsServices {
  
    static listBills = async (page, pageLimit, search,from, to, billStatus,billType) => {
        return await APICall(`/api/Bills/admin/list-bills?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&billStatus=${billStatus}&billType=${billType}`, "GET");
    }
    static viewBill = async (billType) => {
        return await APICall(`/api/Bills/admin/view-bills?billType=${billType}`, "GET", )
    }
    static listData = async (page, pageLimit, search, from, to, billStatus,billType) => {
        return await APICall(`/api/Bills/admin/list-other-bills?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&billStatus=${billStatus}&billType=${billType}`, "GET");
    }
    static exportAirtime = async(search, from, to,billStatus, billType) => {
        return await APICall(`/api/Bills/admin/export-airtime-bills?search=${search}&from=${from}&to=${to}&billStatus=${billStatus}&billType=${billType}`,"GET");
    }
    static exportData = async (search, from, to,billStatus,billType) => {
        return await APICall(`/api/Bills/admin/export-other-bills?search=${search}&from=${from}&to=${to}&billStatus=${billStatus}&billType=${billType}`, "GET")
    } 
    static billSummary = async () => {
        return await APICall(`/api/Bills/admin/bill-summary`,"GET");
    }
    static listMovieUsers  = async (page, pageLimit, search,from, to, movieStatus) => {
        return await APICall(`/api/NairaboxMovie/admin/nairabox/users?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&movieStatus=${movieStatus}`, "GET");
    }
    static exportMovieUsers = async ( search,from, to, movieStatus) => {
        return await APICall(`/api/NairaboxMovie/admin/nairabox/export/users?search=${search}&from=${from}&to=${to}&movieStatus=${movieStatus}`, "GET");
    }
    static listSubscription = async (page, pageLimit, search,from, to, transferStatus,movieSubscriptionStatus) => {
        return await APICall(`/api/NairaboxMovie/admin/nairabox/subscriptions?page=${page}&pageLimit=${pageLimit}&search=${search}&from=${from}&to=${to}&transferStatus=${transferStatus}&movieSubscriptionStatus=${movieSubscriptionStatus}`, "GET");
    }
    static viewMovieUser = async (username) => {
        return await APICall(`/api/NairaboxMovie/admin/nairabox/user?username=${username}`, "GET");
    }
}